export default __webpack_public_path__ + "static/media/lab_disabled.87ca54f1.svg";